import { ChangeEvent, FC, useState, useMemo, useEffect } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useQuery } from 'react-query';
import { CircularProgress, Grid, Paper, Tabs, Tab, Box } from '@material-ui/core';
import { GridColumns, GridCellParams, DataGrid } from '@material-ui/data-grid';
import { useStyles } from './styles';
import { observer } from 'mobx-react-lite';
import EmailIcon from '../../../assets/icons/EndUser/Email.svg';
import { getRowsPerPageOptions } from 'utils/pagination';
import { Search } from 'components/Search';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import { Button, MenuItem } from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import PersonIcon from '@material-ui/icons/Person';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import { handleCompanyUrl } from 'utils/organizationUtils';
import { useHistory } from 'react-router-dom';
import { useMutation } from 'react-query';
import { ConfirmActionDialog } from 'components/Dialogs';
import { UserGroupData } from './types';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { Tooltip } from '@material-ui/core';
import SyncDisabledIcon from '@material-ui/icons/SyncDisabled';
import { red } from '@material-ui/core/colors';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import TabPanel from 'components/TabPanel';
import { Card, CardContent, Typography } from '@material-ui/core';
import GoogleSvg from '../../../assets/googlelogo.svg';
import ZoomSvg from '../../../assets/zoom-logo.png';
import MicrosoftSvg from '../../../assets/microsoft.png';
import GithubSvg from '../../../assets/GitHub-logo.png';
import Timeline from 'components/Timeline';
import { useLocation } from 'react-router-dom';

function useQuer() {
  return new URLSearchParams(useLocation().search);
}
export const GroupTable: FC<any> = observer(() => {
  const {
    groupTableStore: {
      setFilter,
      getUserGroup,
      getManagerGroup,
      getAppGroup,
      usergroupsView,
      deleteGroup,
      deleteManager,
      deleteApp,
    },
    notificationStore: { openNotification },
    endUserSettingsFormStore: { getPortalSettings },
    logsTableStore: { viewUser, viewEndUser },
    ldapStore: { getGroupTimeline },
    userStore: { user },
  } = useStore();

  const query = useQuer();
  const queryValue = query.get('value');
  const defaultTabs = (Array.isArray(queryValue) ? queryValue[0] : queryValue) ?? 'one';
  const [value, setValue] = useState(defaultTabs);
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setValue(params.get('value') || 'one');
  }, [location.search]);

  const handleChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setValue(newValue);

    if (newValue === 'one') {
      history.replace(location.pathname);
    } else {
      history.replace(`${location.pathname}?value=${newValue}`);
    }
  };
  const [openAdd, setOpenAdd] = useState(false);
  const handleClickAwayAdd = () => {
    setOpenAdd(false);
  };
  const handleClickAdd = () => {
    setOpenAdd((prev) => !prev);
  };

  const portalSettingsgetReq = useQuery('portalSettingsgetReq', () => getPortalSettings(), {
    enabled: value === 'one' || value === 'two',
    onError: () => openNotification('error', `Can't get data`),
  });

  const endUserConfigSettings = JSON.parse(localStorage.getItem('endUserConfigSettings') as string);
  const userId = endUserConfigSettings?.userId;
  const history = useHistory();
  const classes = useStyles();
  const [CurrentGroup] = useState<any>(JSON.parse(localStorage.getItem('CurrentGroup') as string));
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);
  const [deleteItemDn, setDeleteItemDn] = useState<string>('');
  const [deleteItemMail, setDeleteItemMail] = useState<string>('');
  const [deleteItemValue, setDeleteItemValue] = useState<string>('');
  const [processedRows, setProcessedRows] = useState<any[]>([]);
  const [selectedManager, setSelectedManager] = useState<UserGroupData | null>(null);
  const [openManagerDialog, setOpenManagerDialog] = useState(false);
  const getClickedUser = useMutation(
    'viewUser',
    (ClientId: number) => (user?.permission !== 'EndUser' ? viewUser(ClientId) : viewEndUser(ClientId)),
    {
      onSuccess: (user) => {
        let url;
        if (user?.data?.message === 'End User Group and Department') {
          url = `${handleCompanyUrl('/admin/profile')}`;
          window.open(url, '_blank');
        }
        localStorage.setItem('ClickedUser', JSON.stringify(user.data.user));
        if (user?.data?.message === 'User found') {
          url = `${handleCompanyUrl('/user/view')}`;
          window.open(url, '_blank');
        } else {
          url = `${handleCompanyUrl('/admin/profile')}`;
          window.open(url, '_blank');
        }
        window.open(url, '_blank');
      },
      onError: (error: any) => {
        openNotification('error', error.data?.message || error.message || 'User not found');
      },
    }
  );

  const timelineReq = useQuery(['groupTimeline', CurrentGroup?.cn], () => getGroupTimeline(CurrentGroup?.cn || ''), {
    enabled: value === 'four',
    refetchOnWindowFocus: false,
    staleTime: 0,
  });

  useEffect(() => {
    if (value === 'four') {
      timelineReq.refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  const getUserGroupReq = useQuery('getUserGroup', () => getUserGroup(CurrentGroup?.dn), {
    enabled: value === 'one',
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    onError: (error: Error) => {
      openNotification('error', error.message);
    },
  });
  const getManagerGroupReq = useQuery('getManagerGroup', () => getManagerGroup(CurrentGroup?.dn), {
    enabled: value === 'two',
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    onError: (error: Error) => {
      openNotification('error', error.message);
    },
  });
  const getAppGroupReq = useQuery('getAppGroup', () => getAppGroup(CurrentGroup?.group_id), {
    enabled: value === 'three',
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    onError: (error: Error) => {
      openNotification('error', error.message);
    },
  });

  const deleteGroupReq = useMutation((data: UserGroupData) => deleteGroup(data, CurrentGroup?.dn), {
    mutationKey: 'deleteGroupReq',
    onSuccess: () => {
      openNotification('success', 'Remove Successfully');
      getUserGroupReq.refetch();
    },
    onError: () => openNotification('error', `Can't Remove User`),
  });
  const deleteManagerReq = useMutation((data: UserGroupData) => deleteManager(data), {
    mutationKey: 'deleteManagerReq',
    onSuccess: () => {
      openNotification('success', 'Manager removed successfully');
      getManagerGroupReq.refetch();
    },
    onError: (error: any) => openNotification('error', error.message),
  });

  const deleteAppReq = useMutation((data: { group_id: number; provider: string }) => deleteApp(data), {
    onSuccess: async () => {
      openNotification('success', 'Deleted successfully');
      getAppGroupReq.refetch();
    },
    onError: (error: any) => openNotification('error', error?.message || 'Delete failed'),
  });

  const handleDelete = (provider: string) => {
    deleteAppReq.mutate({
      group_id: CurrentGroup?.group_id,
      provider: provider,
    });
  };
  const rows = useMemo(() => {
    return !getUserGroupReq.isFetching ? usergroupsView : [];
  }, [getUserGroupReq.isFetching, usergroupsView]);

  const [pageSize, setPageSize] = useState(10);
  const rowsPerPageOptions = useMemo(() => getRowsPerPageOptions(rows), [rows]);
  useEffect(() => {
    const updatedRows = rows.map((item) => {
      let syncGroupGoogleArray: string[] = [];
      let syncGroupZoomArray: string[] = [];
      let syncGroupMicrosoftArray: string[] = [];
      if (item.syncGroup && item.syncGroup !== 'null') {
        try {
          const syncGroup = JSON.parse(item.syncGroup);
          syncGroupGoogleArray = syncGroup.google || [];
          syncGroupZoomArray = syncGroup.zoom || [];
          syncGroupMicrosoftArray = syncGroup.microsoft || [];
        } catch (error) {
          console.error('Error parsing syncGroup:', error);
        }
      }
      const currentGroupDn = CurrentGroup?.dn.toLowerCase().trim();
      const isGoogleMatch = syncGroupGoogleArray.some((value: string) => value.trim().toLowerCase() === currentGroupDn);
      const isZoomMatch = syncGroupZoomArray.some((value: string) => value.trim().toLowerCase() === currentGroupDn);
      const isMicrosoftMatch = syncGroupMicrosoftArray.some(
        (value: string) => value.trim().toLowerCase() === currentGroupDn
      );
      const isSynced = isGoogleMatch || isZoomMatch || isMicrosoftMatch;
      return {
        ...item,
        isSynced,
      };
    });
    setProcessedRows(updatedRows);
  }, [rows, CurrentGroup]);
  const columns: GridColumns = [
    {
      field: 'icon',
      headerName: ' ',
      width: 40,
      align: 'center',
      disableColumnMenu: true,
      renderCell: (params: GridCellParams) => <PersonIcon style={{ color: 'grey' }} />,
    },
    {
      field: 'name',
      headerName: 'FULL NAME',
      flex: 0.8,
      renderCell: (params: GridCellParams) => (
        <Tooltip title={(params.row.givenname || '') + ' ' + (params.row.sn || '')}>
          <div>
            <span>
              {params.row.givenname} {params.row.sn}
            </span>
          </div>
        </Tooltip>
      ),
    },
    // { field: 'sn', headerName: 'LAST', flex: 0.5 },
    // { field: 'givenname', headerName: 'FIRST', flex: 0.5 },
    {
      field: 'uid',
      headerName: endUserConfigSettings?.userId === null || endUserConfigSettings?.userId === '' ? 'UID' : userId,
      flex: 1,
      renderCell: (params: GridCellParams) => {
        const value = String(params.value ?? '');

        return (
          <div
            style={{
              cursor: 'pointer',
              color: '#1976d2',
              textDecoration: 'underline',
            }}
            onClick={(event) => {
              const id = params.row.memberuid || params.row.dn || params.row.uid;
              event.stopPropagation();
              getClickedUser.mutate(id);
            }}
          >
            {value}
          </div>
        );
      },
    },

    {
      field: 'mail',
      headerName: 'EMAIL',
      flex: 1,
      renderCell: (params: GridCellParams) => {
        const value = String(params.value ?? '');
        return (
          <div style={{ display: 'flex', gap: '10px' }}>
            <img src={EmailIcon} alt='' />
            {value}
          </div>
        );
      },
    },
    {
      field: 'syncGroup',
      headerName: 'SYNC',
      flex: 1,
      renderCell: (params: GridCellParams) => {
        const syncGroup = params.row.syncGroup;
        let syncGroupGoogleArray: string[] = [];
        let syncGroupZoomArray: string[] = [];
        let syncGroupMicrosoftArray: string[] = [];
        if (syncGroup && syncGroup !== 'null') {
          try {
            const parsedSyncGroup = JSON.parse(syncGroup);
            syncGroupGoogleArray = parsedSyncGroup.google || [];
            syncGroupZoomArray = parsedSyncGroup.zoom || [];
            syncGroupMicrosoftArray = parsedSyncGroup.microsoft || [];
          } catch (error) {
            console.error('Error parsing syncGroup:', error);
          }
        }
        const currentGroupDn = CurrentGroup?.dn.toLowerCase().trim();
        const isGoogleMatch = syncGroupGoogleArray.some(
          (value: string) => value.trim().toLowerCase() === currentGroupDn
        );
        const isZoomMatch = syncGroupZoomArray.some((value: string) => value.trim().toLowerCase() === currentGroupDn);
        const isMicrosoftMatch = syncGroupMicrosoftArray.some(
          (value: string) => value.trim().toLowerCase() === currentGroupDn
        );
        return (
          <Tooltip
            title={
              isGoogleMatch && isZoomMatch && isMicrosoftMatch
                ? 'Google, Zoom, Microsoft'
                : isGoogleMatch && isZoomMatch
                ? 'Google, Zoom'
                : isGoogleMatch && isMicrosoftMatch
                ? 'Google, Microsoft'
                : isZoomMatch && isMicrosoftMatch
                ? 'Zoom, Microsoft'
                : isGoogleMatch
                ? 'Google'
                : isZoomMatch
                ? 'Zoom'
                : isMicrosoftMatch
                ? 'Microsoft'
                : 'Not Connected'
            }
            placement='bottom'
          >
            <div style={{ position: 'relative', display: 'inline-block', width: '40px', height: '40px' }}>
              <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                {isGoogleMatch && isZoomMatch && isMicrosoftMatch ? (
                  <>
                    <CircularProgress
                      variant='determinate'
                      value={100}
                      size={40}
                      style={{ color: 'green', position: 'absolute', zIndex: 1 }}
                    />
                    <CheckCircleIcon
                      style={{
                        color: 'green',
                        fontSize: '24px',
                        zIndex: 2,
                        margin: '8px',
                      }}
                    />
                  </>
                ) : (isGoogleMatch && isZoomMatch) ||
                  (isGoogleMatch && isMicrosoftMatch) ||
                  (isMicrosoftMatch && isZoomMatch) ? (
                  <>
                    <CircularProgress
                      variant='determinate'
                      value={100}
                      size={40}
                      style={{ color: 'green', position: 'absolute', zIndex: 1 }}
                    />
                    <CircularProgress
                      variant='determinate'
                      value={33.3}
                      size={40}
                      style={{ color: 'grey', position: 'absolute', zIndex: 2 }}
                    />
                    <CheckCircleIcon
                      style={{
                        color: 'green',
                        fontSize: '24px',
                        zIndex: 3,
                        margin: '8px',
                      }}
                    />
                  </>
                ) : isGoogleMatch || isZoomMatch || isMicrosoftMatch ? (
                  <>
                    <CircularProgress
                      variant='determinate'
                      value={100}
                      size={40}
                      style={{ color: 'green', position: 'absolute', zIndex: 1 }}
                    />
                    <CircularProgress
                      variant='determinate'
                      value={66.6}
                      size={40}
                      style={{ color: 'grey', position: 'absolute', zIndex: 2 }}
                    />
                    <CheckCircleIcon
                      style={{
                        color: 'green',
                        fontSize: '24px',
                        zIndex: 3,
                        margin: '8px',
                      }}
                    />
                  </>
                ) : (
                  <SyncDisabledIcon style={{ color: red[500] }} />
                )}
              </div>
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: 'actions',
      headerName: 'ACTIONS',
      width: 160,
      disableColumnMenu: true,
      renderCell: (params: GridCellParams) => (
        <>
          <Tooltip title='Delete User From Group'>
            <IconButton
              size='small'
              onClick={() => {
                setDeleteItemDn(params.row.dn as string);
                setDeleteItemMail(params.row.mail as string);
                setOpenConfirmDialog(true);
              }}
            >
              <DeleteIcon style={{ fill: '#F44336' }} />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];
  const isCurrentTabLoading =
    value === 'one'
      ? getUserGroupReq.isFetching
      : value === 'two'
      ? getManagerGroupReq.isFetching
      : value === 'three'
      ? getAppGroupReq.isFetching
      : value === 'four'
      ? timelineReq.isFetching
      : false;

  useAppPreloader(
    isCurrentTabLoading ||
      deleteManagerReq.isLoading ||
      deleteGroupReq.isLoading ||
      deleteAppReq.isLoading ||
      portalSettingsgetReq.isFetching
  );

  // useAppPreloader(getUserGroupReq.isFetching || getManagerGroupReq.isFetching || getAppGroupReq.isFetching || deleteManagerReq.isLoading || deleteGroupReq.isLoading || deleteAppReq.isLoading || portalSettingsgetReq.isFetching);
  return (
    <>
      <Grid container alignItems='center' className={classes.box}>
        <IconButton
          onClick={() => {
            history.push(handleCompanyUrl('/groups'));
          }}
        >
          <ChevronLeftIcon />
        </IconButton>
        <h1>Group: {CurrentGroup?.cn}</h1>
      </Grid>

      <Tabs
        value={value}
        className={classes.tabs}
        TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
        onChange={handleChange}
      >
        <Tab value='one' label={`Users`} className={classes.label} />
        <Tab value='two' label={`Managers`} className={classes.label} />
        <Tab value='three' label={`Apps`} className={classes.label} />
        <Tab value='four' label={`Timeline`} className={classes.label} />
      </Tabs>

      <TabPanel value={value} index='one'>
        <>
          <Grid container justify='space-between' alignItems='center' className={classes.box}>
            <Search handelSearch={setFilter} />
            <ClickAwayListener onClickAway={handleClickAwayAdd}>
              <div className={classes.root}>
                <Button
                  size='small'
                  variant='contained'
                  color='secondary'
                  className={classes.btnAdd}
                  onClick={handleClickAdd}
                >
                  <AddCircleOutlineIcon />
                </Button>
                {openAdd ? (
                  <div className={classes.dropdown}>
                    <MenuItem
                      className={classes.selectItem}
                      onClick={() => history.push(handleCompanyUrl('/group/add-users'))}
                    >
                      <PersonIcon style={{ color: 'grey' }} /> Add New Users to Group
                    </MenuItem>
                  </div>
                ) : null}
              </div>
            </ClickAwayListener>
          </Grid>
          {getUserGroupReq.isFetching === false && (
            <>
              {rows.length === 0 ? (
                <h1 className={classes.link}> This group has no users associated with it. </h1>
              ) : (
                <Paper className={classes.dataGrid} elevation={0}>
                  <DataGrid
                    className={classes.noBorder}
                    autoHeight
                    rows={processedRows}
                    columns={columns}
                    pageSize={pageSize}
                    rowsPerPageOptions={rowsPerPageOptions}
                    pagination
                    onPageChange={(params) => setPageSize(params.pageSize)}
                  />
                </Paper>
              )}
            </>
          )}
        </>
      </TabPanel>
      <TabPanel value={value} index='two'>
        <Grid container justify='space-between' alignItems='center' className={classes.box}>
          <Search handelSearch={setFilter} />
          <ClickAwayListener onClickAway={handleClickAwayAdd}>
            <div className={classes.root}>
              <Button
                size='small'
                variant='contained'
                color='secondary'
                className={classes.btnAdd}
                onClick={handleClickAdd}
              >
                <AddCircleOutlineIcon />
              </Button>
              {openAdd ? (
                <div className={classes.dropdowns}>
                  <MenuItem
                    className={classes.selectItem}
                    onClick={() => history.push(handleCompanyUrl('/group/add-managers'))}
                  >
                    <PersonIcon style={{ color: 'grey' }} /> Add New Managers to Group
                  </MenuItem>
                </div>
              ) : null}
            </div>
          </ClickAwayListener>
        </Grid>
        {getManagerGroupReq?.isFetching === false && (
          <>
            {getManagerGroupReq?.data && getManagerGroupReq?.data?.length === 0 ? (
              <h1 className={classes.link}> No managers assigned to this group. </h1>
            ) : (
              <DataGrid
                className={classes.noBorder}
                autoHeight
                rows={getManagerGroupReq?.data || []}
                columns={[
                  {
                    field: 'icon',
                    headerName: ' ',
                    width: 40,
                    disableColumnMenu: true,
                    renderCell: () => <SupervisorAccountIcon style={{ color: 'grey' }} />,
                  },
                  {
                    field: 'name',
                    headerName: 'NAME',
                    flex: 1,
                    renderCell: (params: GridCellParams) => {
                      return (
                        <div style={{ display: 'flex', gap: '10px' }}>
                          {params.row.firstName} {params.row.secondName}
                        </div>
                      );
                    },
                  },
                  {
                    field: 'email',
                    headerName: 'EMAIL',
                    flex: 1,
                    renderCell: (params: GridCellParams) => {
                      const value = String(params.value ?? '');
                      return (
                        <div style={{ display: 'flex', gap: '10px' }}>
                          <img src={EmailIcon} alt='' />
                          {value}
                        </div>
                      );
                    },
                  },
                  ...(user?.permission !== 'Manager'
                    ? [
                        {
                          field: 'actions',
                          headerName: 'ACTIONS',
                          width: 160,
                          disableColumnMenu: true,
                          renderCell: (params: GridCellParams) => (
                            <Tooltip title='Delete Manager From Group'>
                              <IconButton
                                size='small'
                                onClick={() => {
                                  setSelectedManager({
                                    group_id: params.row.group_id || CurrentGroup?.group_id,
                                    manager_id: params.row.user_id,
                                  });

                                  setOpenManagerDialog(true);
                                }}
                              >
                                <DeleteIcon style={{ fill: '#F44336' }} />
                              </IconButton>
                            </Tooltip>
                          ),
                        },
                      ]
                    : []),
                ]}
                pageSize={10}
                disableSelectionOnClick
              />
            )}
          </>
        )}
      </TabPanel>
      <TabPanel value={value} index='three'>
        <Grid container justify='flex-end' alignItems='center' className={classes.box}>
          <ClickAwayListener onClickAway={handleClickAwayAdd}>
            <div className={classes.root}>
              <Button
                size='small'
                variant='contained'
                color='secondary'
                className={classes.btnAdd}
                onClick={handleClickAdd}
              >
                <AddCircleOutlineIcon />
              </Button>
              {openAdd ? (
                <div className={classes.dropdowns}>
                  <MenuItem
                    className={classes.selectItem}
                    onClick={() => history.push(handleCompanyUrl('/group/add-apps'))}
                  >
                    <PersonIcon style={{ color: 'grey' }} /> Add New Apps to Group
                  </MenuItem>
                </div>
              ) : null}
            </div>
          </ClickAwayListener>
        </Grid>
        <div className={classes.page}>
          {getAppGroupReq.isFetching === false && (
            <>
              {getAppGroupReq?.data && getAppGroupReq?.data?.length === 0 ? (
                <h1 className={classes.link}>No apps connected to this group.</h1>
              ) : (
                <Grid container spacing={3}>
                  {(getAppGroupReq?.data ?? []).map((app: string, index: number) => {
                    const getAppLogo = (appName: string) => {
                      switch (appName.toLowerCase()) {
                        case 'google':
                          return GoogleSvg;
                        case 'zoom':
                          return ZoomSvg;
                        case 'microsoft':
                          return MicrosoftSvg;
                        case 'github':
                          return GithubSvg;
                        default:
                          return GoogleSvg;
                      }
                    };

                    const getCardClass = (appName: string) => {
                      let className = classes.card;
                      className += ` ${classes.approvedCard}`;
                      return className;
                    };

                    return (
                      <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card className={getCardClass(app)}>
                          <CardContent>
                            {user?.permission !== 'Manager' && (
                              <DeleteIcon
                                className={`${classes.topIcon} ${classes.approvedIcon}`}
                                style={{
                                  color: '#f44336',
                                  fontSize: 28,
                                  cursor: 'pointer',
                                }}
                                onClick={() => handleDelete(app)}
                              />
                            )}
                            <div className={classes.appRow}>
                              <img src={getAppLogo(app)} alt={app} className={classes.appIcon} />
                              <Box>
                                <Typography className={classes.appName}>{app}</Typography>
                                <Typography className={classes.appDesc}>Access granted</Typography>
                              </Box>
                            </div>
                          </CardContent>
                        </Card>
                      </Grid>
                    );
                  })}
                </Grid>
              )}
            </>
          )}
        </div>
      </TabPanel>
      <TabPanel value={value} index='four'>
        <Paper className={classes.dataGrid} elevation={0}>
          <Timeline header='groups' events={timelineReq.data} loading={timelineReq.isLoading} />
        </Paper>
      </TabPanel>

      <ConfirmActionDialog
        label='Remove User'
        buttonLabel='Confirm'
        openModal={openConfirmDialog}
        action={() => {
          deleteGroupReq.mutate({
            uuid: deleteItemDn,
            userEmail: deleteItemMail,
            syncType: deleteItemValue,
          });
        }}
        gitStatus=''
        handleClose={() => {
          setOpenConfirmDialog(false);
          setDeleteItemDn('');
          setDeleteItemMail('');
          setDeleteItemValue('');
        }}
      />
      <ConfirmActionDialog
        label='Remove Manager'
        buttonLabel='Confirm'
        openModal={openManagerDialog}
        action={() => {
          if (selectedManager) {
            deleteManagerReq.mutate(selectedManager);
          }
        }}
        gitStatus=''
        handleClose={() => {
          setOpenManagerDialog(false);
          setSelectedManager(null);
        }}
      />
    </>
  );
});
